import LibraryCatalog from '../model/LibraryCatalog';

export default class LibraryCatalogFilter {

    static filter(catalogList, args) {

        let deviceType = args['deviceType'];
        let deviceLanguage = args['deviceLanguage'];
        let catalogId = args['catalogId'];
        let title = args['title'];

        let res = catalogList;

        if (deviceType)
            res = LibraryCatalogFilter.filterByDeviceType(res, deviceType);

        if (deviceLanguage)
            res = LibraryCatalogFilter.filterByDeviceLanguage(res, deviceLanguage);

        if (catalogId)
            res = LibraryCatalogFilter.filterByCatalogId(res, catalogId);

        if (title)
            res = LibraryCatalogFilter.filterByTitle(res, title);

        return res;
    }

    static filterByDeviceType(catalogList, deviceType) {
        return catalogList.filter((elem, i, array) => {
            return elem.deviceType.length == 0 ||
                elem.deviceType.some((e) => {
                    return e == "ALL" || e == deviceType;
                });
        });
    }

    static filterByDeviceLanguage(catalogList, deviceLanguage) {
        return catalogList.filter((elem, i, array) => {
            return elem.deviceLanguage.length == 0 ||
                elem.deviceLanguage.some((e) => {
                    return e == "ALL" || e == deviceLanguage;
                });
        });
    }

    static filterByCatalogId(catalogList, catalogId) {
        return catalogList.filter((elem, i, array) => {
            return elem.catalogId.toLowerCase() == catalogId.toLowerCase();
        });
    }

    static filterByTitle(catalogList, title) {
        return catalogList.filter((elem, i, array) => {
            return elem.title.toLowerCase().search(title.toLowerCase()) >= 0;
        });
    }

}